import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils';

class ClosureService {
    SearchClosures = async (filters, branchId) => {
        const queryString = utils.GetQueryStringsFromObject({
            ...filters,
            branchId
        })
        return await HttpClient.Get(`/api/closures?${queryString}`);
    }

    GetByClosureId = async (closureId) => 
        await HttpClient.Get(`/api/closures/${closureId}`)

    GetLastClosure = async (cashRegisterId) => 
         await HttpClient.Get(`/api/closures/${cashRegisterId}/last`);
}

export default new ClosureService();